import { createSlice } from "@reduxjs/toolkit";
import ApiAnalytics from "../../api/analytics";

export const AuditAnalyticsSlice = createSlice({
  name: "message-analytics",
  initialState: {
    analytics: [],
    hasMore: false,
    isLoading: false,
  },
  reducers: {
    setAnalytics: (state, action) => {
      // Accept both shapes:
      //   - Legacy: payload is the raw array (older endpoint behavior).
      //   - New:    payload is { items, hasMore } so the server can report
      //             pagination state precisely (no more magic > 28 heuristic).
      const payload = action.payload || {};
      const items = Array.isArray(payload) ? payload : (payload.items || []);
      const hasMore = Array.isArray(payload)
        ? !!(payload.length && payload.length > 28)
        : !!payload.hasMore;

      const newAnalytics = items.filter(
        (newItem) => !state.analytics.some((existingItem) => existingItem.id === newItem.id)
      );
      return {
        ...state,
        analytics: state.analytics ? [...state.analytics, ...newAnalytics] : newAnalytics,
        hasMore,
        isLoading: false,
      };
    },
    resetAnalytics: (state) => ({
      ...state,
      analytics: [],
      hasMore: false,
      isLoading: false,
    }),
    setLoading: (state) => ({ ...state, isLoading: true }),
  },
});

export const { setAnalytics, resetAnalytics, setLoading } = AuditAnalyticsSlice.actions;

export const fetchAnalytics = (query) => (dispatch) => {
  dispatch(setLoading());
  ApiAnalytics.getScenarioAnalytics(query)
    .then((r) => {
      dispatch(setAnalytics({
        items: r.data.analytics,
        hasMore: r.data.hasMore,
      }));
    })
    .catch(() => {
      dispatch(resetAnalytics());
    });
};

export const clearAnalytics = () => (dispatch) => {
  dispatch(resetAnalytics());
};

export const selectAnalytics = (state) => state.messageAnalytics.analytics;
export const selecthasMoreAnalytics = (state) => state.messageAnalytics.hasMore;
export const selectAnalyticsLoading = (state) => state.messageAnalytics.isLoading;

export default AuditAnalyticsSlice.reducer;
